var map = {
	"./avenir_next-bold": 558,
	"./avenir_next-bold.eot": 706,
	"./avenir_next-bold.svg": 558,
	"./avenir_next-bold.ttf": 707,
	"./avenir_next-bold.woff": 708,
	"./avenir_next-bold.woff2": 709,
	"./avenir_next-demi": 559,
	"./avenir_next-demi.eot": 710,
	"./avenir_next-demi.svg": 559,
	"./avenir_next-demi.ttf": 711,
	"./avenir_next-demi.woff": 712,
	"./avenir_next-demi.woff2": 713,
	"./avenir_next-medium": 560,
	"./avenir_next-medium.eot": 714,
	"./avenir_next-medium.svg": 560,
	"./avenir_next-medium.ttf": 715,
	"./avenir_next-medium.woff": 716,
	"./avenir_next-medium.woff2": 717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;